import { render } from "./BetaOptions.vue?vue&type=template&id=6b4a27e5"
import script from "./BetaOptions.vue?vue&type=script&lang=js"
export * from "./BetaOptions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__